export function getAlertContent(typeOfTravel: string): string {
    return `The administrator has disallowed ${typeOfTravel} bookings for this particular study. For further assistance, please contact your system administrator`;
}
